import React from "react";
import PropTypes from "prop-types";
import s from "./Button.module.css";
import classNames from "classnames";
import SVGIcon, { SVGIconColors } from "../SVGIcon/SVGIcon";

export const ButtonVariants = ["primary", "secondary", "icon-only"] as const;
export const ButtonIcons = ["search", "burgundyorangeclose"];
export const ButtonPositions = ["top-right"] as const;

export type ButtonProps = {
  children?: React.ReactNode;
  onClick: () => void;
  variant?: (typeof ButtonVariants)[number];
  icon?: (typeof ButtonIcons)[number];
  disabled?: boolean;
  position?: (typeof ButtonPositions)[number];
  iconColor?: (typeof SVGIconColors)[number];
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = "primary",
  icon = null,
  position,
  disabled = false,
  iconColor,
  ...props
}) => {
  const iconClassNames = classNames(s.icon, {
    [s[icon]]: icon,
  });
  const buttonClasses = classNames(s.button, s[variant], {
    [s[position]]: position,
  });
  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      <span className={s.button_content}>
        {variant !== "icon-only" && children}
        {icon && (
          <SVGIcon
            className={iconClassNames}
            icon={icon}
            color={iconColor}
            alt="Button icon"
          />
        )}
      </span>
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(ButtonVariants),
  icon: PropTypes.oneOf(ButtonIcons), // Använder 'PropTypes.string' för 'icon'
  disabled: PropTypes.bool,
  forwardClass: PropTypes.string,
};

export default Button;
